module.exports = __webpack_public_path__ + "img/current_end.4284dfdc.png";